import clsx from 'clsx';
import React from 'react';

import { getUnreadLabel } from './utils';

export type JobSupportChannelStatus = {
  display: string;
  tone: 'error' | 'info' | 'success' | 'warning';
};

export const JobSupportChannelPreview = ({
  name,
  date = '',
  status,
  time = '',
  unreadCount = 0,
}: {
  name: string;
  date: string;
  status?: JobSupportChannelStatus | null;
  time: string;
  unreadCount: number;
}) => {
  const unreadLabel = getUnreadLabel(unreadCount);

  return (
    <div
      className={clsx('channel-preview__item_job', {
        bold: !!unreadLabel,
      })}
    >
      <div className="channel-preview__name-row">
        {status && (
          <span
            aria-label={`Status: ${status.display}`}
            className={`channel-preview__status-dot channel-preview__status-dot--${status.tone}`}
            role="img"
            title={`Status: ${status.display}`}
          />
        )}
        <div className="channel-preview__name">{name}</div>
      </div>
      <div className="channel-preview__date">{`${date} ${time}`}</div>
      {unreadLabel && (
        <div className="channel-preview__unread-count">{unreadLabel}</div>
      )}
    </div>
  );
};
